<template>
  <el-card>
    <div style="width:50%">
      <el-tree
      :data="deptInfo.deptTreeData0"
      ref="tree"
      node-key="id"
      highlight-current
      :expand-on-click-node = "false"
      :default-expand-all="true"
      :props="deptInfo.defaultProps">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ data.label  }}</span>
          <span>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              style="color:#073559"
              @click="() => editDept(node,data)">
            </el-button>
              <el-button
              type="text"
              size="small"
              icon="el-icon-plus"
              style="color:green"
              v-if="data.level == 0"
              @click="() => addDept(node, data)">
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              style="color:red"
              v-if="data.level != 0 "
              @click="() => removeDept(node, data)">
            </el-button> 
          </span>
        </span> 
      </el-tree>
    </div>
    <el-dialog :visible.sync="dialogVisual.editDeptDialogVisible" v-on:close ="clearEditMneuInfoForm" >
      <div slot="title" class="dialog-footer">
          <span>团队[{{ editDeptForm.dptName }}] 信息变更 </span>
      </div>
      <el-form :model="editDeptForm" label-width="20%"> 
          <el-form-item label="团队名称名称:"  style ="width:80%">
              <el-input v-model="editDeptForm.deptName" autocomplete="off"></el-input>
          </el-form-item>
      
          <el-form-item label="排序编号:"  style ="width:80%">
              <el-input  v-model="editDeptForm.sortNum" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer" >
          <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisual.addDeptDialogVisible" v-on:close ="clearAddDeptInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 添加团队 </span>
      </div>
      <el-form :model="addDeptInfoForm" label-width="20%"> 
          <el-form-item label="团队名称:"  style ="width:80%" >
              <el-input v-model="addDeptInfoForm.deptName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="排序编号:"  style ="width:80%">
              <el-input  v-model="addDeptInfoForm.sortNum" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建团队</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
    <script>
      // 引入组件
      import axios from  '@/api/axiosConfig'
      import {stringIsNullOrEmpty,regCheck} from  '@/api/utils'
      import {PAGE_SIZE,MESSAGE_DURATION,regInteger} from  '@/api/constant'
      export default {
         name : 'pc_ctr_dept',
         data() {
          return {
            tableHeight: 650,
            searchFactor: {
              permissionName: ''     
            },
            tableData: [],
            pager:{
              totalCount:0,
              pageSize : PAGE_SIZE
            },
            dialogVisual:{
              addDeptDialogVisible: false,
              editDeptDialogVisible: false
            },
            editDeptForm: {
              deptName: '',
              sortNum :'',
              id :'',
              node:'',
              nodeBase:''
            },
            addDeptInfoForm: {
              deptName: '',
              sortNum: '',
              node :''
            },
            deptInfo:{
              deptTreeData0: [],
              defaultProps: {
                children: 'children',
                label: 'label'
              }
            },
            formLabelWidth: '120px'
          }
        },
        methods : {
          indexMethod(index){
             return  index + 1
          },
          clearAddDeptInfoForm(){
            this.addDeptInfoForm.deptName = ''
            this.addDeptInfoForm.url =''
            this.addDeptInfoForm.sortNum = ''
            this.addDeptInfoForm.node = ''
          },
          clearEditMneuInfoForm(){
            this.editDeptForm.node = '' 
            this.editDeptForm.deptName = ''
            this.editDeptForm.sortNum = ''
            this.editDeptForm.id = ''
          },
          handleEdit(index, row){
            this.dialogVisual.editPermissionDialogVisible = true
            this.editDeptForm.deptName = row.deptName
            this.editDeptForm.id = row.id
           
          },
          ensureCreate(){ 
            try{ 
              stringIsNullOrEmpty(this.addDeptInfoForm.deptName,'请输团队名称!');
              stringIsNullOrEmpty(this.addDeptInfoForm.sortNum,'请输排序编号!');
              regCheck(regInteger, this.addDeptInfoForm.sortNum, '排序编号必须是正整数')
            }catch (e){
              this.$message({
                    showClose: true,
                    message: e,
                    type: 'error',
                    duration: MESSAGE_DURATION
              }) 
              return
            }
            this.doCreateDeptInfo();
          },
          doCreateDeptInfo(){
            let url = "/bc/exa/dept/addOne"
            let dat = {
              deptName: this.addDeptInfoForm.deptName,
              level: this.addDeptInfoForm.node.level + 1,
              parentId: this.addDeptInfoForm.node.id,
              sortNum: this.addDeptInfoForm.sortNum,
              parentDeptName: this.addDeptInfoForm.node.label
            }
            let s = JSON.stringify(dat)  
            axios.post(url, s).then((response) => {
                if (response.data.code === 0){
                  this.dialogVisual.addDeptDialogVisible= false
                  this.$message({
                    showClose: true,
                    message: '创建成功',
                    type: 'success',
                    duration: MESSAGE_DURATION
                  })
                  let res = response.data.data
                  let children = [] 
                  if(this.addDeptInfoForm.node.children.length !== 0){
                    this.addDeptInfoForm.node.children.forEach(t=>{
                      children.push(t)
                    })
                  }
                  children.push({id : res.id,
                          label : res.deptName,
                          level : res.level,
                          sortNum : res.sortNum,
                          children:[]}) 
                  this.$refs.tree.updateKeyChildren(this.addDeptInfoForm.node.id,children)
                } else {
                  this.$message({
                    showClose: true,
                    message: response.data.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                  })
                }
              }).catch((err) => {
                this.$message({
                    showClose: true,
                    message: err.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                 }) 
            })
          }, 
          initDeptTree(){
            let _this = this;
            let url = "/bc/exa/dept/getDeptTree"
            let data = {}
            let s = JSON.stringify(data)
            axios.post(url, s).then((response) => {
                if (response.data.code === 0){
                  let resData = response.data.data
                  if(resData.length !== 0){
                    let rt = ''
                    let levelOneList = []
                    let levelTwoList = []
                    resData.forEach(t=>{
                      if(t.level == 0 ){
                        rt = { 
                          id : t.id,
                          label : t.deptName,
                          level : t.level,
                          sortNum : t.sortNum,
                          children:[]
                        }
                      }else if ( t.level == 1){
                        levelOneList.push(t)
                      }else if(t.level == 2){
                        levelTwoList.push(t)
                      }
                    }) 
                    if(levelOneList.length !== 0){
                      levelOneList.forEach(t=>{
                        let datOne = { 
                          id:t.id,
                          level : t.level,
                          label: t.deptName,
                          sortNum : t.sortNum,
                          children:[]
                        }
                        rt.children.push(datOne)
                        levelTwoList.forEach(p=>{
                          let datTwo = { 
                            id:p.id,
                            level : p.level,
                            label: p.deptName,
                            sortNum : p.sortNum
                          }
                          if(p.parentId == t.id){
                            datOne.children.push(datTwo)
                          }
                        })
                      })
                    }
                    this.deptInfo.deptTreeData0.push(rt)
                  }else{
                      this.$message({
                      showClose: true,
                      message: '未获取到数据!',
                      type: 'warn',
                      duration: MESSAGE_DURATION
                    })
                  }
                } else {
                  this.$message({
                    showClose: true,
                    message: response.data.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                  })
                }
              }).catch( (err) => {
                this.$message({
                    showClose: true,
                    message: err.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                }) 
            })
          },
          editDept(node,data){
            this.dialogVisual.editDeptDialogVisible = true
            this.editDeptForm.node = data 
            this.editDeptForm.nodeBase = node 
            this.editDeptForm.deptName = data.label
            this.editDeptForm.sortNum = data.sortNum
            this.editDeptForm.id = data.id
          },
          ensureChange(){
            try{ 
              stringIsNullOrEmpty(this.editDeptForm.deptName,'请输团队名称!');
              stringIsNullOrEmpty(this.editDeptForm.sortNum,'请输排序编号!');
              regCheck(regInteger, this.editDeptForm.sortNum, '排序编号必须是正整数')
            }catch (e){
              this.$message({
                    showClose: true,
                    message: e,
                    type: 'error',
                    duration: MESSAGE_DURATION
              }) 
              return
            }
            let url = "/bc/exa/dept/updateOne"
            let dat = {
              deptName: this.editDeptForm.deptName,
              level: this.editDeptForm.node.level ,
              sortNum: this.editDeptForm.sortNum,
              id : this.editDeptForm.id
            }
            let s = JSON.stringify(dat)  
            axios.post(url, s).then((response) => {
                if (response.data.code === 0){
                  this.dialogVisual.editDeptDialogVisible= false
                  this.$message({
                    showClose: true,
                    message: '修改成功',
                    type: 'success',
                    duration: MESSAGE_DURATION
                  })
                  this.$set(this.editDeptForm.node, "label",this.editDeptForm.deptName)
                  this.$set(this.editDeptForm.node, "sortNum",this.editDeptForm.sortNum)
                } else {
                  this.$message({
                    showClose: true,
                    message: response.data.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                  })
                }
              }).catch( (err)=> {
                this.$message({
                    showClose: true,
                    message: err.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                 }) 
            })
          },
          removeDept(node, data){ 
            this.$confirm('即将删除团队['+data.label+']信息', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.doRemoveNode(data)
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消操作！'
              });
            })
          },
          doRemoveNode(data){
            let dat = {
              level: data.level,
              id: data.id
            }
            let s = JSON.stringify(dat)  
            let url = '/bc/exa/dept/deleteDepts';
            axios.post(url, s).then((response) => {
                if (response.data.code === 0){
                  this.$message({
                    showClose: true,
                    message: '操作成功',
                    type: 'success',
                    duration: MESSAGE_DURATION
                  })
                  this.$refs.tree.remove(data)
                } else {
                  this.$message({
                    showClose: true,
                    message: response.data.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                  })
                }
              }).catch( (err) => {
              
                this.$message({
                    showClose: true,
                    message: err.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                 }) 
            })
          },
          addDept(node, data){
            this.dialogVisual.addDeptDialogVisible = true
            this.addDeptInfoForm.node = data 
          },
          
        },
        created () {
            this.initDeptTree();
        },
        components: {
          
        }
    }
    </script>
    
<style lang="less" scoped>
 .el-card {
    height: 99%
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 20px;
  }
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_dept.vue